"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = values;
var _keys2 = _interopRequireDefault(require("./keys.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Retrieve the values of an object's properties.
function values(obj) {
  var _keys = (0, _keys2.default)(obj);
  var length = _keys.length;
  var values = Array(length);
  for (var i = 0; i < length; i++) {
    values[i] = obj[_keys[i]];
  }
  return values;
}